const isNotDomElement = (ancestor) => !(ancestor instanceof HTMLElement);

// noinspection JSUnusedGlobalSymbols
export default isNotDomElement;
